import {booleanAttribute, Component, effect, EventEmitter, inject, input, model, output, Output, signal} from '@angular/core';
import {AppBaseComponent} from '../../../shared/components/app-base-component/app-base-component';
import {Field, form, FormField, submit, validateStandardSchema} from '@angular/forms/signals';
import {ZodAutoValidateDirective} from '../../../shared/decorators/auto-validate/auto-validate';
import {z} from 'zod';
import {SelectField} from '../../../shared/components/select-field/select-field';
import {AttributeService} from '../../../app-code/services/attribute-service';
import {JsonPipe} from '@angular/common';
import {finalize} from 'rxjs';

const userSchema = z.object({
  drinking_habit: z.string().min(1, {message: 'Please select a drinking habit'}),
  smoking_habit: z.string().min(1, {message: 'Please select a smoking habit'}),
  education: z.string().min(1, {message: 'Please select an education'}),
  occupation: z.string().min(1, {message: 'Please select an occupation'}),
  religion: z.string().min(1, {message: 'Please select a religion'}),
  caste: z.string().min(1, {message: 'Please select a caste'}),
  diet: z.string().min(1, {message: 'Please select a diet'}),
  relationship_status: z.string().min(1, {message: 'Please select a status'}),
})

@Component({
  selector: 'app-habits',
  imports: [
    ZodAutoValidateDirective,
    SelectField,
    FormField,
  ],
  templateUrl: './habits.html',
  styleUrl: './habits.css',
})
export class Habits extends AppBaseComponent {
  saved = output();
  onBack = output();
  standalone = input(false, {transform: booleanAttribute});
  formModel = signal({
    drinking_habit: '',
    smoking_habit: '',
    education: '',
    occupation: '',
    religion: '',
    caste: '',
    diet: '',
    relationship_status: '',
  })
  form = form(this.formModel, (schema) => validateStandardSchema(schema, userSchema))
  attributeService = inject(AttributeService);

  constructor() {
    super();
    effect(() => {
      this.formModel.set({
        drinking_habit: this.authService.user()?.drinking_habit?.id?.toString() ?? "",
        smoking_habit: this.authService.user()?.smoking_habit?.id?.toString() ?? "",
        religion: this.authService.user()?.religion?.id?.toString() ?? "",
        caste: this.authService.user()?.caste?.id?.toString() ?? "",
        diet: this.authService.user()?.diet?.id?.toString() ?? "",
        education: this.authService.user()?.education?.id?.toString() ?? "",
        occupation: this.authService.user()?.occupation?.id?.toString() ?? "",
        relationship_status: this.authService.user()?.relationship_status?.id?.toString() ?? "",
      })
    })
  }

  submitForm($event: SubmitEvent) {
    $event.preventDefault();
    if (this.form().invalid()) return;
    this.loading.set(true);
    this.http.post('user/update-profile', {...this.form().value()})
      .pipe(
        finalize(() => {
          this.loading.set(false);
        })
      )
      .subscribe(() => {
        this.saved.emit();
        if (this.standalone()) {
          this.messageService.add({
            severity: 'success',
            key: 'headless',
            summary: 'Profile updated successfully',
          });
        }
      });
  }
}
